export default __webpack_public_path__ + "static/media/Marca-Governo-de-Alagoas-Atualizada.e153f1fb.png";